const initState = {
	timeCoins: 0,
	moneyCoins: 0,
};

export default initState;
